/* eslint-disable @typescript-eslint/no-explicit-any */
// FIXME: fix any
/**
 * Utility function to extract only the dirty (changed) values from form state.
 * Recursively processes nested objects to include only fields that have been modified.
 */
export const getDirtyValues = (dirtyFields: any, allValues: any) => {
  if (typeof dirtyFields !== 'object' || dirtyFields === null) return allValues;
  return Object.keys(dirtyFields).reduce((acc, key) => {
    if (typeof dirtyFields[key] === 'object' && dirtyFields[key] !== null) {
      acc[key] = getDirtyValues(dirtyFields[key], allValues[key]);
    } else if (dirtyFields[key]) {
      acc[key] = allValues[key];
    }
    return acc;
  }, {} as any);
};

/**
 * Typesafe function to sanitize form data by removing keys with undefined and empty array values.
 * @pure
 */
export const sanitizeFormData = <T extends Record<string, any>>(data: T): T => {
  const sanitized = {} as any;
  for (const [key, value] of Object.entries(data)) {
    if (value === undefined) continue;
    if (Array.isArray(value) && value.length === 0) continue;
    sanitized[key] = value;
  }
  return sanitized;
};
